import(/* webpackMode: "eager" */ "C:\\app\\Workspace\\jsws_2_frontend\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager" */ "C:\\app\\Workspace\\jsws_2_frontend\\src\\app\\App.css");
;
import(/* webpackMode: "eager" */ "C:\\app\\Workspace\\jsws_2_frontend\\src\\app\\index.css");
